const key = id => typeof id === 'string' ? id.toLowerCase() : id;
function subtree(rows, id) {
  const ids = new Set([key(id)]);
  let changed = true;
  while (changed) {
    changed = false;
    for (const row of rows) if (ids.has(key(row.parent_id)) && !ids.has(key(row.id))) { ids.add(key(row.id)); changed = true; }
  }
  return rows.filter(row => ids.has(key(row.id)));
}
export function archiveMoveTargets(rows, monthId, folder) {
  if (!Array.isArray(rows) || !rows.some(row => key(row.id) === key(monthId) && row.kind === 'month')) return [];
  const monthRows = subtree(rows,monthId);
  if (!monthRows.some(row => key(row.id) === key(folder.id))) return [];
  const moving = subtree(monthRows,folder.id);
  const excluded = new Set(moving.map(row => key(row.id)));
  const height = Math.max(...moving.map(row => row.depth)) - folder.depth + 1;
  return monthRows.filter(row => !excluded.has(key(row.id)) && row.depth + height <= folder.max_depth).map(row => {
    const parts = [row.name], seen = new Set([key(row.id)]);
    let current = row;
    while (current.parent_id) {
      current = monthRows.find(item => key(item.id) === key(current.parent_id));
      if (!current || seen.has(key(current.id))) break;
      seen.add(key(current.id));parts.unshift(current.name);
    }
    return {...row,label:parts.join(' / ')};
  });
}
